import {useTranslation} from '@/translations/i18n'
import {Opportunity} from '@features/insights/types'
import {FC} from 'react'

interface CardProps {
    opportunity: Opportunity
    onClickReviewButton: () => void
}

export const OpportunityCard: FC<CardProps> = ({opportunity, onClickReviewButton}) => {
    const {t} = useTranslation()

    return (
        <div className="flex flex-col gap-4 border-0 border-b border-neutral-300 rounded-none py-4 shadow-none md:border md:border-neutral-300 md:rounded-2xl md:p-4 md:shadow-xs">
            <h5 className="text-lg font-medium">{t(`insights:issues:reason_title:${opportunity.keyName}`)}</h5>

            <div className="grid w-full grid-cols-4 flex-1 content-end gap-2">
                {opportunity.images.slice(0, 4).map(
                    image =>
                        image?.thumbnails && (
                            <div
                                className="block min-w-0 aspect-[3/2] overflow-hidden rounded-lg border border-black/20"
                                key={`${opportunity.keyName}-${image.id}`}
                            >
                                <img
                                    src={image.thumbnails.xs}
                                    alt={image.name}
                                    className="h-full w-full object-cover object-center"
                                />
                            </div>
                        )
                )}
            </div>

            <div
                className="flex ml-auto cursor-pointer p-2 text-sm font-medium underline"
                onClick={onClickReviewButton}
            >
                {t('insights:issues:review_feedback')}
            </div>
        </div>
    )
}
